var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOnline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    viewBox: "0 0 284 284",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.1,51.6H67.4c-5.9,0-10.7,4.8-10.7,10.7v114.1c0,5.9,4.8,10.7,10.7,10.7h46.3v15.3l-8.3,2.7c-1.5.5-2.4,1.9-2.4,3.4v6.1h-7.1v9.1h60.6v-10.1h-41.3v-2.6l6.7-2.6h34.6v-12.1h-30.6v-9.3h30.6v-12h-86.1c-2,0-2.6-.6-2.6-2.6v-17.4h88.7v-11.1l-87.6-1v-77.3c0-1,.6-2.9,2.6-2.9h142.7c2,0,2.6,1.6,2.6,3.6v47.5h11.1v-51.5c0-5.9-4.8-10.7-10.8-10.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220.7,122.9h-49.9c-3.9,0-7.1,3.2-7.1,7.1v85.6c0,3.9,3.2,7.1,7.1,7.1h49.9c3.9,0,7.1-3.2,7.1-7.1v-85.6c0-3.9-3.1-7.1-7.1-7.1ZM218.7,213.6h-45.9v-8.7h45.9v8.7ZM218.7,195.8h-45.9v-46.9h45.9v46.9ZM218.7,139.7h-45.9v-7.7h45.9v7.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222.3,119.2c3.1,0,5.6-2.5,5.6-5.6s-2.5-5.6-5.6-5.6-5.6,2.5-5.6,5.6,2.5,5.6,5.6,5.6Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOnline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/online.45cdbaed.svg";
export { ForwardRef as ReactComponent };